import Vue from "vue";
import { newLogger } from "@/utils/util";
import network from "../../../utils/network";

let logger = newLogger("UserStore");

const urls = {
  applications: `/merchant/applications`,
  applicationsWithQuery: (query) => `/merchant/applications?${query}`,
  applicationDetails: (applicationId) =>
    `/merchant/application/details/${applicationId}`,
  uploadedDocuments: (applicationId) =>
    `/merchant/application/details/uploaded-documents/${applicationId}`,
  generatedAndSignedDocuments: (applicationId) =>
    `/merchant/application/details/generated-and-signed-documents/${applicationId}`,
};

const initState = () => {
  return {
    applications: [],
    application: {},
    uploadedDocuments: {},
    generatedAndSignedDocuments: {},
  };
};

const actions = {
  fetchList: async ({ commit }, query) => {
    try {
      const axios = await network.connection();
      let url = urls.applications;
      if (query) {
        url = urls.applicationsWithQuery(query);
      }
      let { data } = await axios.get(url);
      commit("saveApplications", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  fetchDetails: async ({ commit }, id) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(urls.applicationDetails(id));
      commit("saveApplication", { data, id });
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  fetchUploadedDocuments: async ({ commit }, id) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(urls.uploadedDocuments(id));
      commit("saveUploadedDocuments", { data, id });
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  fetchGeneratedAndUploadedDocuments: async ({ commit }, id) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(urls.generatedAndSignedDocuments(id));
      commit("saveGeneratedAndSignedDocuments", { data, id });
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
};

const mutations = {
  saveApplications: (state, data) => {
    Vue.set(state, "applications", data);
  },
  saveApplication: (state, { data: data, id: id }) => {
    Vue.set(state.application, id, data);
  },
  saveUploadedDocuments: (state, { data: data, id: id }) => {
    Vue.set(state.uploadedDocuments, id, data);
  },
  saveGeneratedAndSignedDocuments: (state, { data: data, id: id }) => {
    Vue.set(state.generatedAndSignedDocuments, id, data);
  },
};

const getters = {
  getList: (state) => {
    return state.applications;
  },
  getDetails: (state) => (id) => {
    return state.application[id];
  },
  geUploadedDocuments: (state) => (id) => {
    return state.uploadedDocuments[id];
  },
  getGeneratedAndSignedDocuments: (state) => (id) => {
    return state.generatedAndSignedDocuments[id];
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations: mutations,
  actions: actions,
  getters: getters,
};
